import { type CSSProperties } from 'react';

import { type DragType } from '~/components/Shared/Drag/dragTypes';
import { useIsDragging } from '~/hooks/useIsDragging';

type DraggingOverlayProps = {
  itemId: string;
  type: DragType;
  style?: CSSProperties;
};

export const DraggingOverlay = ({ itemId, type, style }: DraggingOverlayProps) => {
  const isDragging = useIsDragging(itemId, type);

  return isDragging ? (
    <div
      className="pointer-events-none absolute ads:bg-base bg-gray-1 opacity-80"
      style={{
        bottom: 0,
        left: 0,
        right: 0,
        top: 0,
        ...style,
      }}
    />
  ) : null;
};
